import { Paper } from 'components/UI/svgIcons'
import { observer } from 'mobx-react-lite'
import User from 'singletons/User'
import Modals from 'singletons/Modals'
import Placeholder from 'components/Dashboard/common/Placeholder'
import { provider } from 'constants/apiBaseUrls'
import FileLinesIcon from '@ui-components-3/icons/lib/solid/FileLines'
import TestIds from 'constants/test-ids'

// Renaming displayTypes
const displayType = {
  hc: 'Health Coaching',
  success: 'Success Coaching',
}

const convertDisplayType = (policyType) => {
  return policyType.replace(/_/g, ' ')
}

const Policies = () => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 py-8 px-12 gap-x-2.5 gap-y-10" data-testid={TestIds.policies.view}>
      {User.provider.policies?.map((policy) => (
        <div key={policy.type}>
          <h5 className="mb-2.5 typography-body-xxl text-primary-800 capitalize">
            {/* Grab a maped value, if it does not exist then replace underscores with spaces */}
            {displayType[policy.type] || convertDisplayType(policy.type)}
          </h5>
          {policy.list.map((policy) => (
            <p
              className="flex items-start typography-body-l tracking-tight cursor-pointer text-primary-800 hover:text-primary-600 gap-2.5 mb-2"
              onClick={() => {
                const pdfUrl = `${provider || ''}/v1/policies/${policy.fileId}`
                Modals.open('pdfViewer', { pdfUrl })
              }}
            >
              <FileLinesIcon className="w-4 h-4 shrink-0 mt-1" aria-hidden="true" />
              <span className="underline">{policy.name}</span>
            </p>
          ))}
        </div>
      )) || <Placeholder text="No Policies Found" icon="" />}
    </div>
  )
}

export default observer(Policies)
